import { useAuthContext } from "../utils/hooks/useAuthContext";
import { ReactElement } from "react";
import { ROUTES } from "../utils/constants";
import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoute(): ReactElement {
  const { user, authIsReady } = useAuthContext();

  if (!user) {
    return <Navigate to={ROUTES.ADMIN_LOGIN} replace />;
  }

  return <Outlet />;
}
